import { FC } from 'react';

interface SixDotsIconProps {
  color?: string;
  size?: number;
}

export const SixDotsIcon: FC<SixDotsIconProps> = ({ color, size = 20 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.6" cy="3.6" r="1.6" fill={color} />
      <circle cx="12.4008" cy="3.6" r="1.6" fill={color} />
      <circle cx="7.6" cy="10.0004" r="1.6" fill={color} />
      <circle cx="12.4008" cy="10.0004" r="1.6" fill={color} />
      <circle cx="7.6" cy="16.3998" r="1.6" fill={color} />
      <circle cx="12.4008" cy="16.3998" r="1.6" fill={color} />
    </svg>
  );
};
